import { useState } from 'react';

export default function DynamicContentGenerator({ settingsData = [], formState, handleChange }) {
  
  // Group data by ParentName
  const grouped = settingsData.reduce((acc, item) => {
    if (!acc[item.ParentName]) acc[item.ParentName] = [];
    acc[item.ParentName].push(item);
    return acc;
  }, {});

  console.log('Grouped Settings Data:', settingsData ,grouped, formState);


  return (
    <div className="p-4 space-y-2">
      {Object.entries(grouped).map(([parent, items]) => (
        <div key={parent} className="border-b p-4 rounded ">
          <h2 className="text-xl font-semibold mb-4">{parent}</h2>
          <div className="space-y-2 flex flex-col w-full">
            {items.map((item) => (
              <div key={item.SetupDetailId} className="flex items-center gap-4 w-full">
                {item.Flex2 === 'CHECKBOX' ? (
                  <div className='flex items-center gap-2'>
                    <input
                      type="checkbox"
                      id={`setting-${item.SetupDetailId}`}
                      checked={formState[item.SetupDetailId] === 'true'}
                      onChange={(e) =>
                        handleChange(item.SetupDetailId, e.target.checked)
                      }
                    />
                    <label htmlFor={`setting-${item.SetupDetailId}`}>
                      {item.SetupDetailName}
                    </label>
                  </div>
                ) : (
                  <div className='flex items-center justify-around gap-2 w-full'>
                    <label
                      htmlFor={`setting-${item.SetupDetailId}`}
                      className="w-full font-medium "
                    >
                      {item.SetupDetailName}
                    </label>
                    <input
                      type="text"
                      id={`setting-${item.SetupDetailId}`}
                      value={formState[item.SetupDetailId] || ''}
                      onChange={(e) =>
                        handleChange(item.SetupDetailId, e.target.value)
                      }
                      className="border px-2 py-1 rounded w-full max-w-sm"
                    />
                    {
                      item.Hint && (
                        <span className="text-gray-500 text-sm w-full">
                          {item.Hint}
                        </span>
                      )
                    }
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
